import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, LayersControl, useMap } from "react-leaflet";
import { Phone, Mail, MapPin, Linkedin, MapPinHouse } from 'lucide-react';
import "leaflet/dist/leaflet.css";
import "./Footer.css";
import Logo from '../../assets/images/LOGO_BLANC.png';
import PinMap from '../../assets/images/map-pin.png';
import { Link } from "react-router-dom";
import L from "leaflet";
const { BaseLayer } = LayersControl;

// Composant pour invalider la taille de la carte
function InvalidateSize() {
  const map = useMap();
  useEffect(() => {
    const timer = setTimeout(() => {
      map.invalidateSize();
    }, 100);
    return () => clearTimeout(timer);
  }, [map]);
  return null;
}


// Fix icône Leaflet (React n'inclut pas les assets automatiquement)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

const CONTACT = {
  tel: "+33 3 28 62 80 01",
  mail: "contact@meca-gtech.fr",
  address: "25 Ter, Chem. de la Distillerie, 59380 Steene",
  lat: 50.960217541242805,
  lng: 2.343178230644259,
};

const LEGAL_PAGES = [
  { name: "Mentions légales", url: "/legale-notice" },
  { name: "Plan du site", url: "/site-map" },
  { name: "Réalisation", url: "/realisation" },
];

export default function Footer() {
  return (
    <footer style={{
      background: "#011F37",
      color: "#fff",
      fontSize: "1rem"
    }}>
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "2rem",
        padding: "2rem 15rem 1rem 15rem",
        alignItems: "center",
        justifyContent: "space-between"
      }}>
        {/* Contact Info */}
        <div style={{ textAlign: "left" }}>

          <Link to="/" style={{ textDecoration: "none", color: "#fff" }}>
            <img src={Logo} alt="logo" style={{width: "10vw"}} className="links" />
          </Link>

          
          <Link to="/contact" style={{ textDecoration: "none", color: "#fff" }}>
            <h3 className="links">Nous contacter</h3>
          </Link>
          <p style={{color: "#fff", marginTop: "1rem"}}>
            <strong><Phone size={16} /></strong> <a href={`tel:${CONTACT.tel}`} className="links">{CONTACT.tel}</a><br />
            <strong><Mail size={16} /></strong> <a href={`mailto:${CONTACT.mail}`} className="links">{CONTACT.mail}</a><br />
            <strong><MapPin size={16} /></strong> <a href='https://maps.app.goo.gl/NgXaCdnYJatTQT126' target="blank_" className="links">{CONTACT.address}</a>
          </p>

          {/* Social Media */}
          <div style={{ textAlign: "left", alignItems: "center", display: "flex", flexDirection: "row", marginTop: "1.5rem" }}>
            <a href="https://www.linkedin.com/company/meca-gtech/" target="blank_" className="links">
              <Linkedin size={16} /> Suivez-nous sur LinkedIn
            </a>
          </div>
        </div>
        {/* OpenStreetMap */}
        <div style={{ minWidth: "10vw", maxWidth: "25vw", flex: "1" }} className="map-container">
          <MapContainer
            center={[CONTACT.lat, CONTACT.lng]}
            zoom={16}
            style={{
              height: "300px",
              width: "100%",
              borderRadius: "1rem",
            }}
            scrollWheelZoom={false}
          >
            <InvalidateSize />
            <LayersControl position="topright">
              {/* Carte OSM standard */}
              <BaseLayer name="Carte OSM">
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenStreetMap contributors"
                />
              </BaseLayer>

              {/* Vue satellite Esri */}
              <BaseLayer checked name="Satellite">
                <TileLayer
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                  attribution="Tiles © Esri, Maxar, Earthstar Geographics"
                />
              </BaseLayer>
            </LayersControl>

            {/* Marqueur */}
            <Marker 
              position={[CONTACT.lat, CONTACT.lng]} 
              className="map-marker"
              icon={L.icon({ 
                iconUrl: PinMap,
                className: 'map-marker-icon'
              })}
            >
              <Popup><MapPinHouse size={16}/> Notre atelier est ici</Popup>
            </Marker>
          </MapContainer>

          <small>
            <a
              href={`https://www.openstreetmap.org/?mlat=${CONTACT.lat}&mlon=${CONTACT.lng}#map=18/${CONTACT.lat}/${CONTACT.lng}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#fff" }}
            >
              Voir sur OpenStreetMap
            </a>
          </small>
        </div>
      </div>
      {/* Legal Pages */}
      <div style={{
        marginTop: "2rem",
        padding: "0.5rem",
        backgroundColor: "#001322ff",
        fontSize: "0.85rem",
        textAlign: "center",
        opacity: 0.7
      }}>
        {LEGAL_PAGES.map((page, idx) => (
          <React.Fragment key={page.url}>
            <Link to={page.url} style={{color: "#fff", margin: "0 0.5rem"}}>{page.name}</Link>
            {idx < LEGAL_PAGES.length - 1 && "|"}
          </React.Fragment>
        ))}
      </div>
    </footer>
  );
}